import React from 'react'
import { withRouter } from 'react-router'
import TermContractList from '../components/term-contract'
import TermContractProfile from '../components/term-contract/profile'

const TermContractsPage = ({ match }) => {
    const { termContractId } = match.params
    return termContractId
        ? <TermContractProfile key={termContractId} termContractId={termContractId} />
        : <TermContractList />
}

export default withRouter(TermContractsPage)



// WEBPACK FOOTER //
// ./src/containers/term-contracts-page.js